import { apiClient } from '@/shared/services/api/client';
import { unwrapEnvelope } from '@/shared/services/api/envelope';
import type { ApiEnvelope } from '@/shared/services/api/envelope';
import type { SupplierDashboardSummary } from '../models/supplierDashboard.types';

/**
 * The Supplier Dashboard's own endpoint (2026-10-29, NB-637): the KPI cards' figures, `GET /supplier-bids/summary`
 * (backend `modules/quotation`). The BID Calendar reads the supplier's BIDs through `supplierQuotationService`, the
 * one module that knows the list. Like it, there is no mock branch: tests replace this module with `vi.mock`.
 */

const FALLBACK = 'The dashboard could not be loaded. Please try again.';

/* A refused read is the dashboard's news to report in place, not grounds to leave the portal (as the BIDs list). */
const allowForbidden = { _allowForbidden: true } as const;

export const supplierDashboardService = {
  async summary(): Promise<SupplierDashboardSummary> {
    return unwrapEnvelope(
      await apiClient.get<ApiEnvelope<SupplierDashboardSummary>>('/supplier-bids/summary', allowForbidden),
      FALLBACK,
    );
  },
};

export type SupplierDashboardService = typeof supplierDashboardService;
